import { Style, styled } from 'inlines'
import { useState, useEffect } from 'react'

type ImageProps = {
  style?: Style
  src: string
  alt?: string
  onClick?: () => void
  onLoad?: () => void
  onError?: () => void
}

export const Image = ({
  style,
  src,
  alt,
  onClick,
  onLoad,
  onError,
}: ImageProps) => {
  const [hasError, setHasError] = useState(false)

  // Reset error state when src changes
  useEffect(() => {
    setHasError(false)
  }, [src])

  const handleError = () => {
    onError?.()
    setHasError(true)
  }

  if (hasError) {
    return null
  }

  return (
    <styled.img
      src={src}
      alt={alt || ''}
      onClick={onClick}
      onLoad={onLoad}
      onError={handleError}
      draggable="false"
      style={style}
    />
  )
}
